import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ec59b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portal-home-header" }
const _hoisted_2 = { class: "portal-home-header-container" }
const _hoisted_3 = { class: "portal-home-header-title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("修改密码")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("退出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_ChangePwdDialog = _resolveComponent("ChangePwdDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.isHenanBc ? 'HNBC' : _ctx.isNuwa
          ? '中国妇瘤大数据平台（NUWA平台）'
          : '智能医学科研云平台'), 1),
      _createVNode(_component_a_dropdown, { class: "portal-home-header-user" }, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, { onClick: _ctx.userMenuClick }, {
            default: _withCtx(() => [
              (_ctx.isInHospEnv)
                ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_menu_item, { key: "1" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_button, { ghost: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.state.userInfo.user_real_name) + " ", 1),
              _createVNode(_component_UserOutlined)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ChangePwdDialog)
  ]))
}